import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-160">
      <div className="relative w-11 h-11 md:w-14 md:h-14 rounded-lg overflow-hidden ring-2 ring-accent shadow-[0_0_15px_rgba(220,38,38,0.4)] shrink-0" data-id="element-161">
        <img src="https://cdn.magicpatterns.com/uploads/5Z1reBaEShoek9WJ62kXJ3/ChatGPT_Image_Jun_25,_2026,_09_08_57_PM.png" alt="Joel Reynolds Pressure Washing logo" className="w-full h-full object-cover" data-id="element-162" />
      </div>
      <div className="flex flex-col" data-id="element-163">
        <span className="font-display text-xl md:text-2xl text-white leading-none tracking-wider uppercase" data-id="element-164">
          Joel Reynolds
        </span>
        <span className="text-[10px] md:text-xs text-accent font-bold tracking-[0.2em] uppercase" data-id="element-165">
          Pressure Washing
        </span>
      </div>
    </div>;
}